// eslint-disable-next-line
import tw from "twin.macro";
import ServicesSection from "../components/Sections/ServicesSection";
import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const Services = () => {
  return (
    <Layout>
      <Seo title="Services" description="Check out our Enterprise Service and Individual Service." />
      <ServicesSection />
    </Layout>
  );
};

export default Services;
